import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import { mieterstromInvoicingApiWithoutCamelization } from "../../../api/subApis/mieterstromInvoicingApi";
import type { Contract } from "../../DeliveryOverview/DeliveryOverview.types";

interface UseContractsProps {
  projectId: string | undefined;
}

function useContracts({ projectId }: UseContractsProps) {
  const {
    isLoading,
    error,
    data: contracts
  } = useQuery({
    queryKey: mieterstromInvoicingApiWithoutCamelization.contracts.key(
      projectId || ""
    ),
    queryFn: projectId ? () => fetchContracts(projectId) : skipToken
  });

  return {
    isLoading,
    error,
    contracts
  };
}

async function fetchContracts(projectId: string) {
  const response = await apiWithoutCamelization.get<Array<Contract>>(
    mieterstromInvoicingApiWithoutCamelization.contracts.url(projectId)
  );
  return response.data;
}

export { useContracts };
